import {Routes} from '@angular/router';
import {LoginComponent} from './login.component';
import {LogoutComponent} from '../logout/logout.component';

export const loginRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'logout',
        component: LogoutComponent
    }
];


// WEBPACK FOOTER //
// ./src/app/login/login.routes.ts